// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"579":"b1dd28b1","799":"940f5b82"}[chunkId] + ".chunk.js";
};